import React, { useState } from 'react';
import { useDataProvider, Button as AdminButton, useTranslate, Confirm, WithPermissions, useRecordContext, useResourceContext } from 'react-admin';
import { GET_ONE } from 'ra-core';
import Avatar from "@mui/material/Avatar";
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import AttachmentIcon from '@mui/icons-material/Attachment';
import DeleteIcon from '@mui/icons-material/Delete';
import { FUNCTION_URL } from '../../../Constants/index';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DownloadIcon from '@mui/icons-material/Download';
import FormatListBulletedTwoToneIcon from '@mui/icons-material/List';
import { useSnackbar } from 'notistack';

var attachments = [];

function FileListDialog() {
    const [open, setOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);

    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const { enqueueSnackbar } = useSnackbar();

    const record = useRecordContext();
    const resource = useResourceContext();

    const handleClose = () => {
        setOpen(false);
        setSelectedValue(null);
    }

    const handleListItemClick = async (value) => {
        var blobName = value.currentTarget.id;
        var params = {
            blobName: blobName,
            permissions: "r",
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        await fetch(FUNCTION_URL + '/getcontainersas', {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                if (response.status === 200) {
                    response.text().then(text => {
                        let body = JSON.parse(text)
                        if (body) {
                            let url = body.url;
                            let a = document.createElement('a');
                            a.href = url;
                            a.click();
                        }
                        else {
                            showMessage(translate('tim.fileListDialog.error'), "error");
                        }
                    });
                }
                else {
                    showMessage(translate('tim.fileListDialog.error'), "error");
                }
            })
            .catch(error => {
                console.log(error);
                return error;
            });
    };

    const handleConfirm = async () => {
        var blobName = selectedValue;
        let data = JSON.stringify({
            resource: resource,
            serial_number: record.serial_number_tim,
            id: record.id,
            filename: blobName
        });

        await fetch(FUNCTION_URL + '/deletefile', {
            method: 'POST',
            headers: {
                'x-zumo-auth': localStorage.getItem('auth-token')
            },
            body: data
        })
            .then(response => {
                if (response.status === 200) {
                    showMessage(translate('tim.fileListDialog.deleted'), "success");
                    setOpen(false);
                    setSelectedValue(null);
                }
                else {
                    showMessage(translate('tim.fileListDialog.error'), "error");
                    setOpen(false);
                    setSelectedValue(null);
                }
            })
            .catch(error => {
                console.log(error);
                showMessage(translate('tim.fileListDialog.error'), "error");
                return error;
            });

        setConfirmOpen(false);
    }

    const handleOpen = async () => {
        let dbRecord = await dataProvider(GET_ONE, resource, { id: record.id })
            .then(
                response => {

                    if (response.data.error) {
                        showMessage(translate('tim.fileListDialog.error'), "error");
                        setOpen(false);
                    }
                    else if (response.data) {
                        attachments = response.data.attachments;
                        setOpen(true);
                    }
                })
            .catch(error => {
                console.log(error);
                showMessage(translate('tim.fileListDialog.error'), "error");
            });
    }

    const handleDeleteItemOpen = (value) => {
        setConfirmOpen(true);
        setSelectedValue(value.currentTarget.id);
    }

    const handleDeleteItemClose = () => {
        setConfirmOpen(false);
    }

    const showMessage = (message, level) => {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }

    return (
        <div>
            <AdminButton label='tim.fileListDialog.button_label' onClick={handleOpen.bind(this)} >
                <FormatListBulletedTwoToneIcon />
            </AdminButton>
            <Dialog
                disableEnforceFocus
                onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={open}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="simple-dialog-title">File</DialogTitle>
                <MenuList>
                    {attachments.map(attachment => (
                        <MenuItem
                            key={attachment.path}
                            id={attachment.path}
                        >
                            <ListItemAvatar>
                                <Avatar >
                                    <AttachmentIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={attachment.name}
                                primaryTypographyProps={{ noWrap: true }} />
                            <ListItemSecondaryAction>
                                <Button
                                    onClick={handleListItemClick}
                                    key={attachment.path}
                                    id={attachment.path} >
                                    <DownloadIcon />
                                </Button>
                                <WithPermissions
                                    render={({ permissions }) =>
                                        permissions === 'magazziniere' &&
                                        <AdminButton
                                            onClick={handleDeleteItemOpen}
                                            id={attachment.name} >
                                            <DeleteIcon />
                                        </AdminButton>
                                    } />
                                <Confirm
                                    isOpen={confirmOpen}
                                    title='tim.fileListDialog.confirmation_title'
                                    content='tim.fileListDialog.confirmation_message'
                                    onConfirm={handleConfirm}
                                    onClose={handleDeleteItemClose}
                                    confirm='tim.fileListDialog.confirm'
                                    cancel='tim.fileListDialog.cancel'
                                />
                            </ListItemSecondaryAction>
                        </MenuItem>
                    ))}
                </MenuList>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus><div>{translate('tim.fileListDialog.cancel')}</div></Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default FileListDialog;
